import { IsNotEmpty, IsArray, IsString } from 'class-validator';

export class ParameterKeyQueryDTO {

    @IsNotEmpty()
    @IsArray()
    @IsString({
        each: true
    })
    keys: Array<string>;

}
